import React from 'react';
import BasePipelineStepComponent from '../base_pipeline_step';
import {SORT_ASC, SORT_DESC} from "../../../../models/pipeline/steps/column_actions/sort_column";

export default class SortColumnStepComponent extends BasePipelineStepComponent {
    action_present = 'Sort table';
    action_past = 'Sorted table';

    async onChange(ev) {
        await super.onChange(ev);
        super.onSave(ev);
    }

    getIcon() {
        return `transformations-sort-${this.props.step.isAscending() ? 'asc' : 'desc'}`;
    }

    updateStep(ev, step) {
        step.setSort(ev.currentTarget.dataset['direction']);
    }

    canEdit() {
        return false;
    }

    renderHeader() {
        const {step} = this.props;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Sort table by <span className="column-highlight">{step.column.title_name}</span>
            </div>
        );
    }

    renderForm(results) {
        const {step} = this.props;

        return (
            <>
                <img
                    alt=""
                    src="images/sort-asc.png"
                    data-direction={SORT_ASC}
                    className={`image-sort ${step.isAscending() ? 'selected' : ''}`}
                    onClick={this.onChange}
                />
                <img
                    alt=""
                    src="images/sort-desc.png"
                    data-direction={SORT_DESC}
                    className={`image-sort ${step.isDescending() ? 'selected' : ''}`}
                    onClick={this.onChange}
                />
            </>
        );
    }

    renderValue() {
        const {step} = this.props;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Sorted table by <span className="column-highlight">{step.column.title_name}</span> {step.isAscending() ? 'ascending' : 'descending'}
            </div>
        );
    }
}
